import React, { useContext, useState } from 'react'
import CustomerContext from 'Components/CustomComponents/Context/CustomerContext';
import GridLogic from '../Grid/GridLogic'

function NewDocStatus(){
    const {
        cookies
    } = useContext(CustomerContext)
    const [defaultColDefs] = useState([
        {headerName:'SHT',field:'SHTCompliance',cellStyle:ChangeBackground},
        {headerName:'I9',field:'I9Compliance',cellStyle:ChangeBackground},
        {headerName:'W4',field:'W4Compliance',cellStyle:ChangeBackground},
        {headerName:'Arbitration',field:'ArbStatus',cellStyle:ChangeBackground},
        {headerName:'E-Verified',field:'Everified', cellStyle:ChangeBackground},
        {headerName:'Background',field:'BackGroundCompliance', valueFormatter:CapitalizeComplete, cellStyle:ChangeBackground},
        {headerName:'Drug Test',field:'DrugCompliance',cellStyle:ChangeBackground},
        {headerName:'First Name',field:'FirstName'},
        {headerName:'Last Name',field:'LastName'},
        {headerName:'Employee ID', field:'employeeid',cellClass:'linked-cell'},
        {headerName:'Rep', field:'RepName'},
        {headerName:'Customer',field:'CustName'},
        {headerName:'Department',field:'DeptName'},
        {headerName:'Assignment ID',field:'assignmentID', cellClass:'linked-cell'},
        {headerName:'Days on Assignment', field:'DaysOnAssginment'},
        {headerName:'Hours on Assignment',field:'TotalHours'},
        {headerName:'Last Pay Date',field:'LastPayDate',valueFormatter: (date)=>{return TransformDate(date)}},
        {headerName:'Order Type',field:'OrderType'},
    ]);
    const REACT_APP_API_URL = process.env.REACT_APP_API_URL;
    const [currentGrid] = useState('DocStatus');
    const [currentPage] = useState('Dashboard');
    const [apiUrl] = useState(`${REACT_APP_API_URL}/Compliance/GetDocStatusByBranch?token=${cookies.get('customer').Token}`);
    const [customerColumnDefs] = useState([
        {headerName:'Employee ID', field:'employeeid',cellClass:'linked-cell'},
        {headerName:'First Name',field:'FirstName'},
        {headerName:'Last Name',field:'LastName'},
        {headerName:'SHT',field:'SHTCompliance',cellStyle:ChangeBackground},
        {headerName:'I9',field:'I9Compliance',cellStyle:ChangeBackground},
        {headerName:'W4',field:'W4Compliance',cellStyle:ChangeBackground},
        {headerName:'E-Verified',field:'Everified', cellStyle:ChangeBackground},
        {headerName:'Drug Test',field:'DrugCompliance',cellStyle:ChangeBackground},
        {headerName:'Background',field:'BackGroundCompliance'},
        {headerName:'Covid',field:'CovidCompliance'},
        {headerName:'Days on Assignment', field:'DaysOnAssginment'},
        {headerName:'Hours on Assignment',field:'TotalHours'},
        {headerName:'Customer',field:'CustName'},
        {headerName:'Department',field:'DeptName'},
        {headerName:'Branch',field:'BranchName'},
    ]);
    const [show] = useState(false);

    function ChangeBackground(params){
        if(params.value){
            params.value=params.value.trim()
            if(params.value==='NA'){
                return {backgroundColor: 'rgb(202 202 202)'}
            }else if(params.value==='No'||params.value==='Waiting on Candidate'||params.value==='Started but incomplete'){
                return {backgroundColor: '#f5ff91'}
            // }else if(params.value==='Needs Review'||params.value==='Waiting on SR to finish'){
            //     return {backgroundColor: 'rgb(252 191 118)'}
            }else if(params.value === 'Yes'||params.value === 'Complete - Authorized'||params.value==='Completed - Accepted'||params.value==='Pass'||params.value==='Pass'){
                return {backgroundColor: '#9dff9e'};
            }else if(params.value==='Completed - Rejected'||params.value==='Complete - Not Authorized'||params.value==='Fail'){
                return {backgroundColor: '#ed2938'}
            }else{
                return {backgroundColor: '#f5ff91'}
            }
        }
    }

    function CapitalizeComplete(data){
        if(data.value==='complete'){
            return 'Complete'
        }
        return data.value
    }

    function TransformDate(date){
        if(date.value){
            return date.value.split('T')[0];
        }else{
            return 'None'
        }
    }

    function HandleClick(e){
        if(e.colDef.field==='employeeid'){
            openInNewTab('https://beyond.ontempworks.com/employee/'+e.data.employeeid)
        }else if(e.colDef.field==='assignmentID'){
            openInNewTab('https://beyond.ontempworks.com/assignment/'+e.data.assignmentID)

        }
    }

    const openInNewTab = (url) => {
        const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
        if (newWindow) newWindow.opener = null
    }

    function SortData(data){
        let filteredData = [];
        data.forEach(candidate=>{
            candidate.Everified = candidate.Everified.trim();
            if(candidate.Everified==='No'||candidate.SHTCompliance==='No'||candidate.I9Compliance==='No'||candidate.BackgroundCompliance==='Needs Review'){
                filteredData.push(candidate)
            }
        })
        return filteredData
    }

    return(
        <GridLogic
            popupInfo={{
                show:show,
            }}
            currentPage={currentPage}
            currentGrid={currentGrid}
            apiUrl={apiUrl}
            defaultColDefs={defaultColDefs}
            customerColumnDefs={customerColumnDefs}
            HandleClick={HandleClick}
            SortData={SortData}
        ></GridLogic>
    )
}

export default NewDocStatus;